module.exports = __webpack_public_path__ + "media/images/client_footer__background--desktopDown-7437e1b75ac3b42b5b411b2844bb9f5b.png";